/* PEAKFORM THEME — theme.js */

document.addEventListener('DOMContentLoaded', function () {

  /* ── SIZE SELECTOR ── */
  var LOW_STOCK_THRESHOLD = 10;

  function updateStockIndicator(btn) {
    var indicator = document.getElementById('stock-indicator');
    if (!indicator || !btn) return;
    var qty = parseInt(btn.dataset.inventory, 10);
    if (!isNaN(qty) && qty > 0 && qty < LOW_STOCK_THRESHOLD) {
      indicator.textContent = 'Only ' + qty + ' left in stock';
      indicator.style.display = 'block';
    } else {
      indicator.textContent = '';
      indicator.style.display = 'none';
    }
  }

  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = this.closest('.size-grid');
      if (group) group.querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var variantInput = document.getElementById('selected-variant');
      if (variantInput) variantInput.value = this.dataset.variantId || '';
      updateStockIndicator(this);
    });
  });

  var initialActiveBtn = document.querySelector('.size-btn.active');
  if (initialActiveBtn) updateStockIndicator(initialActiveBtn);

  /* ── ADD TO CART (AJAX) ── */
  function getSelectedVariantId() {
    var el = document.getElementById('selected-variant');
    return el ? el.value : '';
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function (r) { return r.json(); });
  }

  var addToCartForm = document.getElementById('add-to-cart-form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = getSelectedVariantId();
      if (!variantId) {
        alert('Please select a size.');
        return;
      }
      var btn = document.getElementById('add-to-cart-btn');
      var originalText = btn ? (btn.dataset.originalText || btn.textContent) : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }
      addToCart(variantId)
        .then(function () {
          updateCartCount();
          if (btn) { btn.textContent = 'Added!'; }
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 2000);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  }

  /* ── BUY NOW (AJAX add, then straight to checkout) ── */
  var buyNowBtn = document.getElementById('buy-now-btn');
  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var variantId = getSelectedVariantId();
      if (!variantId) {
        alert('Please select a size.');
        return;
      }
      var originalText = buyNowBtn.textContent;
      buyNowBtn.textContent = 'Redirecting...';
      buyNowBtn.disabled = true;
      addToCart(variantId)
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNowBtn.textContent = originalText;
          buyNowBtn.disabled = false;
          alert('Something went wrong. Please try again.');
        });
    });
  }

  /* ── CART COUNT ── */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      });
  }
  updateCartCount();

  /* ── NEWSLETTER FORMS ── */
  document.querySelectorAll('.newsletter-form, .footer-email-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button');
      if (input && btn) {
        btn.textContent = '✓';
        input.value = '';
        setTimeout(function () { btn.textContent = '→'; }, 3000);
      }
    });
  });

  /* ── MOBILE NAV TOGGLE ── */
  var mobileToggle = document.querySelector('.nav-mobile-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      var open = mobileNav.style.display === 'block';
      mobileNav.style.display = open ? 'none' : 'block';
    });
  }

});
